<template>
  <div class="manage">

    <el-dialog
      :title="deductForm.type === 'add' ? '新增罚款' : '更新罚款'"
      :visible.sync="deductForm.isShow"
    >
      <el-form ref="deductForm" label-width="150px" :model="deductForm.formData" size="mini" :rules="deductForm.rules">
        <el-form-item label="姓名" label-width="140px" style="width: 340px" prop="name">
          <el-input
            placeholder="请输入姓名"
            v-model.trim="deductForm.formData.name"
            @input="fetchIdCardOptions"
          />
        </el-form-item>

        <el-form-item label="身份证号" label-width="140px" style="width: 340px" prop="idCard" v-if="showIdCard">
          <el-select
            placeholder="请选择身份证号"
            v-model="deductForm.formData.idCard"
          >
            <el-option
              v-for="option in idCardOptions"
              :value="option.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="罚款日期" label-width="140px" style="width: 340px" prop="startDate">
          <el-date-picker v-model="deductForm.formData.startDate" placeholder="请选择罚款日期"/>
        </el-form-item>
        <el-form-item label="罚款金额" label-width="140px" style="width: 340px" prop="deduct">
          <el-input-number
            :min="0" :precision="3"
            placeholder="罚款金额"
            v-model.trim="deductForm.formData.deduct"
          />
        </el-form-item>
        <el-form-item label="备注" label-width="140px" style="width: 340px" prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}"
                    v-model.trim="deductForm.formData.remark"
                    maxlength="100"
                    show-word-limit style="width:100%"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="deductForm.isShow = false">取消</el-button>
        <el-button type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>

    <!--操作-->
    <div style="margin-bottom: 10px">
      <!--      <el-upload :action="importApi" :headers="headers" accept="xlsx" :show-file-list="false"-->
      <!--                 :on-success="handleImportSuccess" :multiple="false"-->
      <!--                 style="display:inline-block">-->
      <!--        <el-button type="success" size="mini"-->
      <!--        >导入 <i class="el-icon-bottom"></i>-->
      <!--        </el-button>-->
      <!--      </el-upload>-->
      <!--      <el-button type="warning" size="mini" @click="exportData" style="margin-left: 10px"-->
      <!--      >导出 <i class="el-icon-top"></i>-->
      <!--      </el-button>-->
      <el-button type="primary" @click="handleAdd" size="mini"
      >新增 <i class="el-icon-circle-plus-outline"></i>
      </el-button>
    </div>

    <!------------------------- 搜索 -------------------------------->
    <div class="manage-header">
      <el-form label-width="auto" :model="searchForm.formData"
               :inline="true" size="mini">
        <el-form-item label="姓名" prop="name">
          <el-input
            placeholder="请输入姓名"
            v-model.trim="searchForm.formData.name"
            prefix-icon="el-icon-search"
          />
        </el-form-item>
        <el-form-item label="部门" prop="deptId">
          <el-select
            placeholder="请选择部门"
            v-model="searchForm.formData.deptId"
          >
            <el-option
              v-for="option in searchForm.deptList"
              :key="option.id"
              :label="option.name"
              :value="option.id"
              :disabled="option.disabled"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="mini">搜索 <i class="el-icon-search"/></el-button>
          <el-button type="danger" @click="reset" size="mini">重置 <i class="el-icon-refresh-left"/></el-button>
        </el-form-item>
      </el-form>
    </div>
    <!------------------------ 数据表格 ----------------------->
    <div class="common-table">
      <el-table
        :data="table.tableData"
        height="85%"
        border
        stripe
        row-key="id"
        :header-cell-style="{background: '#eef1f6',color: '#606266',
        textAlign:'center',fontWeight:'bold',borderWidth:'3px'}"
      >
        <el-table-column prop="code" label="工号" min-width="80" align="center"/>
        <el-table-column prop="name" label="姓名" min-width="80" align="center"/>
        <el-table-column prop="deptName" label="部门" min-width="125" align="center"/>
        <el-table-column prop="phone" label="电话" min-width="125" align="center"/>
        <el-table-column prop="createTime" label="提交罚款时间" min-width="180" align="center"/>
        <el-table-column prop="startDate" label="罚款日期" min-width="125" align="center"/>
        <el-table-column prop="deduct" label="罚款金额" min-width="80" align="center"/>
        <el-table-column prop="remark" label="备注" width="200" align="center"/>
        <el-table-column label="操作" width="190" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="reject(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        layout="total,sizes,prev,pager,next,jumper"
        :page-size="table.pageConfig.size ? table.pageConfig.size : 10"
        :page-sizes="[5, 10, 15, 20]"
        :total="table.pageConfig.total"
        :current-page.sync="table.pageConfig.current"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { add, edit, getList } from '@/api/deduct'
import { getList as getList1 } from '../../../api/staff'
import { getAllDept } from '@/api/dept'

export default {
  name: 'Leave',
  data () {
    return {
      showIdCard: true,
      idCardOptions: [],
      deductForm: {
        type: 'add', // add为新增，edit为编辑
        isShow: false,
        formData: {},
        rules: {
          // typeNum: [
          //   { required: true, message: '请选择', trigger: 'change' }
          // ],
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          idCard: [
            { required: true, message: '请输入身份证号', trigger: 'blur' }
          ],
          startDate: [
            { required: true, message: '请选择罚款日期', trigger: 'blur' }
          ],
          days: [
            { required: true, message: '请输入罚款金额', trigger: 'blur' }
          ]
        }
      },
      searchForm: {
        deptList: [],
        formData: {}
      },
      searchFormIdCard: {
        formData: {}
      },
      table: {
        tableData: [],
        pageConfig: {
          total: 10, // 记录总数
          current: 1, // 起始页
          size: 10 // 每页展示的记录数
        }
      }
    }
  },
  methods: {
    fetchIdCardOptions () {
      this.searchFormIdCard.formData.name = this.deductForm.formData.name
      getList1({
        current: this.table.pageConfig.current,
        size: this.table.pageConfig.size,
        deptId: this.$store.state.staff.staff.deptId
      }, this.searchFormIdCard.formData).then(response => {
        if (response.code === 200) {
          this.idCardOptions = response.data.list.map(item => {
            return {
              value: item.idCard
            }
          })
        } else {
          this.$message.error(response.message)
        }
      })
    },
    confirm () {
      this.$refs.deductForm.validate(valid => {
        if (valid) {
          if (this.showIdCard) {
            add(this.deductForm.formData).then(response => {
              if (response.code === 200) {
                this.$message.success('提交成功！')
                this.deductForm.isShow = false
                this.loading()
              } else {
                this.$message.error('提交失败')
              }
            })
          } else {
            edit(this.deductForm.formData).then(response => {
              if (response.code === 200) {
                this.deductForm.isShow = false
                this.loading()
                this.$message.success('修改成功')
              }
            })
          }
        } else {
          return false
        }
      })
    },
    handleAdd () {
      this.showIdCard = true
      this.deductForm.isShow = true
      this.deductForm.type = 'add'
      this.deductForm.formData = {}
    },
    reject (row) {
      this.showIdCard = false
      this.deductForm.isShow = true
      this.deductForm.type = 'edit'
      this.deductForm.formData = row
    },
    handleSizeChange (size) {
      this.table.pageConfig.size = size
      this.loading()
    },
    handleCurrentChange (current) {
      this.table.pageConfig.current = current
      this.loading()
    },
    search () {
      this.loading()
    },
    // 重置搜索表单
    reset () {
      this.searchForm.formData = {}
      this.loading()
    },
    // 将数据渲染到模板
    loading () {
      getAllDept(this.$store.state.staff.staff.deptId).then(response => {
        const list = []
        response.data.forEach(dept => {
          if (dept.children.length > 0) {
            dept.disabled = true
            list.push(dept)
            dept.children.forEach(subDept => {
              list.push(subDept)
            })
          }
        })
        this.searchForm.deptList = list
      })
      getList({
        current: this.table.pageConfig.current,
        size: this.table.pageConfig.size,
        name: this.searchForm.formData.name,
        deptId: this.searchForm.formData.deptId,
        myDeptId: this.$store.state.staff.staff.deptId
      }).then(response => {
        if (response.code === 200) {
          this.table.tableData = response.data.list
          this.table.pageConfig.total = response.data.total
        } else {
          this.$message.error(response.message)
        }
      })
    },
    // 导出数据
    exportData () {
      window.open(getExportApi())
    },
    handleImportSuccess (response) {
      if (response.code === 200) {
        this.$message.success('数据导入成功！')
        this.loading()
      } else {
        this.$message.error('数据导入失败！')
      }
    }
  },
  created () {
    this.loading()
  }
}
</script>
<style lang="less" scoped>
.common-table {
  height: calc(100% - 62px);
  background-color: white;
  position: relative;

  .pager {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
}

</style>
